<template>
  <!--begin::Card-->
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header py-3">
      <div class="card-title align-items-start flex-column">
        <h3 class="card-label font-weight-bolder text-dark">确认开票信息</h3>
        <span class="text-muted font-weight-bold font-size-sm mt-1"
          >请确认你的开票信息</span
        >
      </div>
      <div class="card-toolbar">
        <button
          type="reset"
          class="btn btn-success mr-2"
          @click="save()"
          ref="kt_save_changes"
        >
          提交
        </button>
        <button type="reset" class="btn btn-secondary" @click="cancel()">
          取消
        </button>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <AddInvTitle
      v-bind:dialog.sync="invTitleDialog"
      :action="action"
    ></AddInvTitle>
    <div class="card card-custom card-shadowless rounded-top-0">
      <div class="card-body p-0">
        <div class="row justify-content-center py-8 px-8 py-lg-15 px-lg-10">
          <div class="col-xl-12 col-xxl-7">
            <!--begin: Wizard Form-->
            <form class="form mt-0 mt-lg-10" id="kt_form">
              <!--begin: Wizard Step 1-->
              <div
                class="pb-5"
                data-wizard-type="step-content"
                data-wizard-state="current"
              >
                <div class="col-lg-9 col-xl-6">
                  <h5 class="font-weight-bold mt-3 mb-2">发票抬头</h5>
                </div>

                <div class="form-group">
                  <select
                    name="country"
                    class="form-control form-control-solid form-control-lg"
                    v-model="form['inv_title._id']"
                    v-if="inv_title_list.length > 0"
                  >
                    <template v-for="item in inv_title_list">
                      <option
                        v-bind:key="item._id['$oid']"
                        :value="item._id['$oid']"
                      >
                        {{ item.business_name }}
                      </option>
                    </template>
                  </select>
                  <b-alert v-else :show="true" variant="secondary"
                    >暂无发票信息，<b-link @click="addInvTitle"
                      >添加发票抬头</b-link
                    ></b-alert
                  >
                </div>

                <div class="col-lg-9 col-xl-6">
                  <h5 class="font-weight-bold mt-3 mb-2">
                    待开票金额<span class="text-warning">{{
                      form.inv_prices / 100
                    }}</span
                    >元
                  </h5>
                </div>

                <div class="form-group">
                  <v-select
                    v-model="expendValues"
                    :items="expendItems"
                    item-text="memo"
                    item-value="_id"
                    label="选择消费记录"
                    multiple
                    chips
                    :hint="hint"
                    persistent-hint
                  ></v-select>
                </div>

                <div class="col-lg-9 col-xl-6">
                  <h5 class="font-weight-bold mt-3 mb-2">
                    填写发票备注（选填）
                  </h5>
                </div>

                <div class="form-group">
                  <textarea
                    v-model="form.memo"
                    cols="25"
                    rows="5"
                    class="form-control form-control-solid form-control-lg"
                    placeholder="如果有额外要求，请备注说明"
                  >
                  </textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--end::Form-->
  </div>
</template>

<script>
import { postInstance, getInstance } from "@/api/instance";
import AddInvTitle from "@/view/pages/invoice/AddInvTitle";

export default {
  name: "InvTitle",
  data() {
    return {
      email: "",
      expendValues: [],
      hint: "",
      expendItems: [],
      form: {
        "inv_title._id": "",
        inv_prices: 0,
        memo: "",
        "expends._id": [],
      },
      inv_title_list: [],
      invTitleDialog: false,
      action: "add",
      waitOpenVoicePrices: 0,
      expendList: [],
    };
  },
  components: {
    AddInvTitle,
  },
  watch: {
    expendValues: {
      handler: function () {
        this.sumInvPrices();
      },
      deep: true,
    },
  },
  created() {
    // this.current_photo = this.currentUser.photo;
    this.fetchInvTitle();
    this.fetchExpend();
  },
  methods: {
    sumInvPrices() {
      this.form.inv_prices = 0;
      this.expendValues.forEach((value) => {
        this.expendList.forEach((item) => {
          if (value === item._id["$oid"]) {
            this.form.inv_prices += item.expend;
          }
        });
      });
    },
    save() {
      // set spinner to submit button
      const submitButton = this.$refs["kt_save_changes"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send post request
        this.addInvoice();

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 1000);
    },
    cancel() {
      this.$router.push({ name: "invoice" });
    },
    fetchExpend() {
      this.states = [];
      getInstance("EXPEND", { open_invoice_status: 0 }).then((res) => {
        this.hint = "共有 " + res.result.length + " 条消费明细可申请开票";
        res.result.forEach((item) => {
          const data = {};
          const itemDate = this.$moment.unix(item.ctime).format("YYYY/MM/DD");
          data.memo =
            itemDate +
            " " +
            item.memo +
            " " +
            "可开票金额" +
            item.expend / 100 +
            "元";
          data._id = item._id["$oid"];
          this.expendItems.push(data);
        });
        this.expendList = res.result;
      });
    },
    fetchInvTitle() {
      getInstance("INVTITLE").then((res) => {
        if (res.result.length !== 0) {
          this.inv_title_list = res.result;
          this.form["inv_title._id"] = res.result[0]["_id"]["$oid"];
        }
      });
    },
    addInvoice() {
      this.form["expends._id"] = this.expendValues;
      postInstance("INVOICE", this.form).then(() => {
        this.$router.push({ name: "invoice" });
      });
    },
    addInvTitle() {
      this.invTitleDialog = true;
    },
  },
};
</script>
